import React, { useState } from 'react';
import CustomerModal from '../CustomerModal';

const OrderCustomerSelector = ({ customers, onSelect, onClose, onAddCustomer }) => {
  const [search, setSearch] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  const filteredCustomers = (Array.isArray(customers) ? customers : []).filter(customer => {
    const fullName = `${customer.imie || ''} ${customer.nazwisko || ''}`.toLowerCase();
    const companyName = (customer.nazwa_firmy || '').toLowerCase();
    const email = (customer.email || '').toLowerCase();
    const s = search.toLowerCase();
    return fullName.includes(s) || companyName.includes(s) || email.includes(s);
  });

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1060
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px',
        maxWidth: '700px', width: '95%', maxHeight: '85vh',
        overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', color: 'var(--text)' ,
          padding: '0.5rem 0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>Wybierz klienta</h3>
          <button
            onClick={onClose}
            style={{ padding: '4px 10px', backgroundColor: 'var(--bg-secondary)', color: 'var(--text-secondary)', border: '1px solid var(--border)', cursor: 'pointer', fontSize: '11px' }}
          >
            X
          </button>
        </div>

        <div style={{ padding: '0.5rem' }}>
          <div style={{ display: 'flex', gap: '6px', marginBottom: '0.5rem' }}>
            <input
              type="text"
              placeholder="Szukaj klienta..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
              style={{ flex: 1, padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
            />
            <button
              type="button"
              onClick={() => setShowAddForm(true)}
              style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: '1px solid var(--success)', color: 'var(--success)' }}
            >
              + Dodaj
            </button>
          </div>

          <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
            {filteredCustomers.length === 0 ? (
              <div style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
                <p style={{ margin: 0 }}>Brak klientow do wyswietlenia</p>
                {search && (
                  <button
                    onClick={() => setShowAddForm(true)}
                    style={{ marginTop: '0.5rem', padding: '6px 12px', fontSize: '12px', border: '1px solid var(--success)', cursor: 'pointer', backgroundColor: 'var(--card-bg)', color: 'var(--success)' }}
                  >
                    + Dodaj nowego klienta
                  </button>
                )}
              </div>
            ) : (
              filteredCustomers.map((customer, index) => (
                <div
                  key={customer.id}
                  onClick={() => onSelect(customer)}
                  style={{
                    padding: '0.5rem', backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)',
                    borderBottom: '1px solid var(--border)', cursor: 'pointer', fontSize: '10px'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <div>
                      <div style={{ fontWeight: '600', marginBottom: '2px' }}>
                        {customer.nazwa_firmy || `${customer.imie || ''} ${customer.nazwisko || ''}`.trim()}
                      </div>
                      {customer.email && <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>Email: {customer.email}</div>}
                      {(customer.phone || customer.telefon) && (
                        <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>Tel: {customer.phone || customer.telefon}</div>
                      )}
                    </div>
                    <span style={{ fontSize: '9px', color: 'var(--text-muted)', padding: '2px 4px', backgroundColor: 'var(--border)', borderRadius: '3px' }}>
                      ID: {customer.id}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <CustomerModal
        isOpen={showAddForm}
        onClose={() => setShowAddForm(false)}
        onSuccess={(newCustomer) => { setShowAddForm(false); onAddCustomer(newCustomer); }}
      />
    </div>
  );
};

export default OrderCustomerSelector;
